import {
  AggregateOnlyInsightPayload,
  InsightMetric,
  BaseInsightPayload,
  validateInsightStructure,
} from '../InsightDataPayload';
import { InsightCatalogue } from '../InsightCatalogue';

export interface CapacityManagementAllocatedHoursPayload
  extends AggregateOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ALLOCATED_HOURS;
    id: string;
    attributes: {
      aggregate: {
        total_allocated_hours: InsightMetric;
      };
    };
  };
}

export const parseCapacityManagementAllocatedHoursPayload = (
  payload: BaseInsightPayload
): CapacityManagementAllocatedHoursPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ALLOCATED_HOURS,
    data.attributes,
    false,
    true,
    ['total_allocated_hours']
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    aggregate: { total_allocated_hours: InsightMetric };
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_CAPACITY_MANAGEMENT_ALLOCATED_HOURS,
      id: data.id,
      attributes: {
        aggregate: {
          total_allocated_hours:
            typedAttributes.aggregate.total_allocated_hours,
        },
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
